import { Error } from "@progress/kendo-react-labels";
import { useState, useEffect } from "react";
import { MarginsGrid } from ".";
import productsApi from "../../../api/products";
import { useFetch } from "../../../hooks/useApi";
import { useUserContext } from "../../../hooks/useUserContext";
import { ConfigurationsFilters, IProductFilters } from "../configurations";
import { objectToLookup } from "../../../utilities/objectUtilities";

export const Margins = () => {
  const { context: user } = useUserContext();
  const companyId = user.activeCompany.id;

  const [businessTypesList, setBusinessTypesList] = useState<any[]>([]);
  const [commodityTypesList, setCommodityTypesList] = useState<any>({});
  const [filter, setFilter] = useState<IProductFilters | null>(null);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(true);

  const getBusinessTypesApi = useFetch(productsApi.getBusinessTypesByCompany, companyId);
  const commoditiesApi = useFetch(productsApi.getCommodities);
  const commodityTypesApi = useFetch(productsApi.getCommodityTypes);

  useEffect(() => {
    setBusinessTypesList(objectToLookup(getBusinessTypesApi.data?.businessTypes || []));
  }, [getBusinessTypesApi.data]);

  useEffect(() => {
    setLoading(commoditiesApi.loading || commodityTypesApi.loading);
  }, [commoditiesApi.loading, commodityTypesApi.loading]);

  useEffect(() => {
    if (commodityTypesApi.data?.commodityTypes)
      setCommodityTypesList(commodityTypesApi.data.commodityTypes);
  }, [commodityTypesApi.data]);

  return (
    <>
      {commoditiesApi.error && <Error>{commoditiesApi.error}</Error>}
      {commodityTypesApi.error && <Error>{commodityTypesApi.error}</Error>}

      <div style={isEditing ? { visibility: "hidden", display: "none" } : {}}>
        <ConfigurationsFilters
          businessTypes={getBusinessTypesApi.data?.businessTypes}
          commodityTypes={commodityTypesList}
          onChangeFilters={setFilter}
        />
      </div>

      {!loading && (
        <MarginsGrid
          businessTypesList={businessTypesList}
          commodities={commoditiesApi.data?.commodities}
          filter={filter}
          onEdit={setIsEditing}
        />
      )}
    </>
  );
};
